import { cn } from '@/utils/common';
import type { HTMLMotionProps } from 'framer-motion';

const classes = {
  rootWrapper: cn(
    'fixed z-[1000] top-0 left-0 w-screen h-screen',
    'flex flex-col justify-center items-center overflow-hidden bg-white',
  ),

  contentWrapper: cn('flex flex-col justify-center items-center gap-8'),
};

const animationProps: Record<string, HTMLMotionProps<'div'>> = {
  rootWrapper: {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.3, delay: 0.1 } },
  },

  contentWrapper: {
    initial: { opacity: 0, y: 15, transition: { duration: 0.3, delay: 0.1 } },
    animate: { opacity: 1, y: 0 },
  },
};

export { animationProps, classes };
